module.exports = __webpack_public_path__ + "img/Squeezing-out-the-benefits-of-GC-reports.362326c9.png";